export const QueryKey = {
  CATEGORIES: 'categories',
  CATEGORY: 'category',
  TEMPLATE: 'template',
  TEMPLATES: 'templates',
  TEMPLATE_SCHEMAS: 'templateSchemas',
  SURVEY_RESPONSE: 'surveyResponse',
  SURVEY_RESPONSES: 'surveyResponses',
} as const;